function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { getActionStringForCTAType, getHandoffUrl, isAvailableInThisRegion, isOpenInNewWindowButton } from '@shared/utils/appUtils';
import { getTooltipSilentLogIn } from '@shared/utils/silentLogInUtils';
import SpzaComponent from '@shared/components/spzaComponent';
import { BaseCtaButton } from '@shared/components/baseCtaButton';
import { PrimaryButton, mergeStyleSets, DefaultButton } from '@fluentui/react';
import { openInNewWindowButtonStyles } from '@shared/components/contentStyles';
import { hidePowerBiVisualPricing } from '@shared/utils/pricing';
const ctaButtonsClassNames = mergeStyleSets({
    ctaButton: {
        padding: '5px 25px',
        marginTop: 4,
        marginRight: 8
    }
});
// eslint-disable-next-line @typescript-eslint/ban-types
export class CtaButtons extends SpzaComponent {
    componentDidMount() {
        var _getWindow_performance, _getWindow;
        const window = getWindow();
        const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
        if (window) {
            window.loadTimePDPCTA = performance.now() - (requestStart - navigationStart);
        }
    }
    ctaDefaultButton(ctaType, isOpenInNewWindow) {
        const { startingPrice, isLoadingUserData, onCTAClick } = this.props;
        const { loc } = this.context;
        return /*#__PURE__*/ _jsx(DefaultButton, {
            text: loc(getActionStringForCTAType(ctaType)),
            className: classNames([
                ctaButtonsClassNames.ctaButton,
                'pdpButton',
                {
                    [openInNewWindowButtonStyles.openInNewWindowButton]: isOpenInNewWindow
                }
            ]),
            disabled: !isAvailableInThisRegion({
                startingPrice
            }) || isLoadingUserData,
            onClick: ()=>onCTAClick(ctaType),
            iconProps: isOpenInNewWindow ? {
                iconName: 'OpenInNewWindow'
            } : {}
        }, ctaType);
    }
    ctaPrimaryButton(ctaType, isOpenInNewWindow) {
        const { startingPrice, isLoadingUserData, onCTAClick, isEmbedded, app } = this.props;
        const { loc } = this.context;
        const isPBIVisualPriceHidden = hidePowerBiVisualPricing({
            app,
            isEmbedded
        });
        return /*#__PURE__*/ _jsx(PrimaryButton, {
            text: isPBIVisualPriceHidden && ctaType === Constants.CTAType.Install ? loc('CTA_Install_free', 'Install free') : loc(getActionStringForCTAType(ctaType)),
            className: classNames([
                ctaButtonsClassNames.ctaButton,
                'requestButton',
                {
                    [openInNewWindowButtonStyles.openInNewWindowButton]: isOpenInNewWindow
                }
            ]),
            disabled: !isAvailableInThisRegion({
                startingPrice
            }) || isLoadingUserData,
            onClick: ()=>onCTAClick(ctaType),
            iconProps: isOpenInNewWindow ? {
                iconName: 'OpenInNewWindow'
            } : {}
        }, ctaType);
    }
    renderImpl() {
        const { app, startingPrice, isLoadingUserData, billingCountryCode, isEmbedded, openInNewWindowButtonFlag } = this.props;
        const url = getHandoffUrl(app);
        const buttons = app.ctaTypes.map((ctaType, index)=>{
            const isOpenInNewWindow = openInNewWindowButtonFlag && isOpenInNewWindowButton({
                isEmbedded,
                ctaType,
                appData: app,
                billingRegion: billingCountryCode,
                url
            });
            const button = index ? this.ctaDefaultButton(ctaType, isOpenInNewWindow) : this.ctaPrimaryButton(ctaType, isOpenInNewWindow);
            const baseCtaCompoent = /*#__PURE__*/ _jsx(BaseCtaButton, {
                app: app,
                billingCountryCode: billingCountryCode,
                startingPrice: startingPrice,
                isLoadingUserData: isLoadingUserData,
                CtaComponent: button,
                ctaType: ctaType
            });
            return getTooltipSilentLogIn(baseCtaCompoent, isLoadingUserData);
        });
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: buttons
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
CtaButtons.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
